module.exports = function() {
  return new Worker(__webpack_public_path__ + "1d324b998051b09fae1a.worker.js");
};